import { Card, Select } from "antd";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const data = [
  { name: "0 - 20%", learners: 1000, color: "#FFA6A1" },
  { name: "21 - 40%", learners: 3800, color: "#FFCE99" },
  { name: "41 - 60%", learners: 1800, color: "#FFE178" },
  { name: "61 - 80%", learners: 2400, color: "#54F9B3" },
  { name: "81 - 100%", learners: 2800, color: "#00A96B" },
];

export default function LearnersProgressChart() {
  return (
    <Card
      className="shadow-sm bordered-card custom-card"
      title={
        <span className="text-theme-slate-800 text-lg font-medium">
          Learners Progress Distribution
        </span>
      }
      extra={
        <Select
          defaultValue="7days"
          size="small"
          className="w-32"
          options={[{ label: "Last 7 days", value: "7days" }]}
        />
      }
    >
      <div className="h-80 w-full mt-4">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} barSize={35}>
            <CartesianGrid
              strokeDasharray="3 3"
              vertical={false}
              stroke="#E2E8F0"
            />
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#64748B", fontSize: 12 }}
              dy={10}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#64748B", fontSize: 12 }}
            />
            <Tooltip cursor={{ fill: "transparent" }} />
            <Bar dataKey="learners" radius={[4, 4, 0, 0]}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
